
export interface UpdateEFBRequest {
    id: number;
    onBlockFuel: number | null | undefined;
    fuelUpliftLtr: number |  null | undefined;
    offBlockFuel: number | null | undefined;
    comment: string | null | undefined;
    density: number | null | undefined;
    receiptDate: Date;
}
